import React from 'react';
import './Gallery.css'
import {isMobile } from 'react-device-detect';

function Gallery({ images,
  imgWidth = null,
  imgHeight = null,
  imgMaxHeight = null,
  imgMinHeight = null,
  perRow = null,
  imgMargin = "5px",
  galleryHeight = "auto",
  galleryPadding = null,
  overflowY = null,
  mImgMaxHeight = imgMaxHeight,
  mImgMargin = imgMargin
}) {


  let imageStyles = {
    width: imgWidth,
    height: imgHeight,
    maxHeight: imgMaxHeight,
    minHeight: imgMinHeight,
    borderRadius: "7%",
    margin: imgMargin
  }

  let galleryStyles = { maxHeight: galleryHeight, overflowY: overflowY, padding: galleryPadding }
  if (isMobile) {
    galleryStyles = {
      ...galleryStyles,
      overflowX: "auto",
      whiteSpace: "nowrap"
    }

    imageStyles = {
      ...imageStyles,
      display: 'inline-block',
      maxHeight: mImgMaxHeight,
      margin: mImgMargin
    }
  }
  return (
    <div className="c_gallery has-text-centered" style={galleryStyles}>

      {images.map((image, i) => {
        return (
          <React.Fragment key={image}>
            <img
              key={image}
              style={imageStyles}
              src={image}
              alt={`The OG Collection - ${i}`} />
            {perRow && ((i + 1) % perRow === 0) && <br />}

          </React.Fragment>
        )
      })}

    </div>
  );
}


export default Gallery;